var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D14925",
    d: "M14.12 8.34c-1.566 0-2.835-1.27-2.835-2.835v-3.78h-7.56c-1.044 0-1.89.846-1.89 1.89V14.01c0 1.044.846 1.89 1.89 1.89H16.01c1.044 0 1.89-.846 1.89-1.89V8.34h-3.78zm-1.89-2.835c0 1.044.846 1.89 1.89 1.89h3.389L12.23 2.116v3.389zM3.725.78h8.505l6.615 6.615v6.615c0 1.566-1.27 2.835-2.835 2.835H3.725c-1.566 0-2.835-1.27-2.835-2.835V3.615C.89 2.049 2.16.78 3.725.78zm0 3.78h5.67v.945h-5.67V4.56zm0 3.78h5.67v.945h-5.67V8.34zm0 3.78H16.01v.945H3.725v-.945z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.4d9ac8c8e639173ff17c4d5a127dfe53.svg";
export { ForwardRef as ReactComponent };